module.exports = __webpack_public_path__ + "static/media/gaming.c3726dc2.png";